// Module
var code = "<div class=\"basket-email\"> <div class=\"basket-email__icon\" tabindex=\"0\"> <i class=\"material-icons-outlined\">email</i> </div> <span class=\"basket-email__label\">[[EmailBasket]]</span> </div> ";
// Exports
module.exports = code;